// Theme: jade-dragon
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'jade-dragon',
  name: 'JADE DRAGON',
  tagline: 'JADE DRAGON',
  description: 'Verde jade ancestral com presenca oriental intensa.',
  category: 'fantasy-realms',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0A1410', '#102018', '#047857', '#D1FAE5'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-sans theme-jade-dragon'
  },
  colorVars: {
    '--accent': '#047857',
    '--accent-foreground': '#0A1410',
    '--background': '#0A1410',
    '--border': '#6B5218',
    '--card': '#102018',
    '--card-border-active': 'rgba(212,175,55,0.60)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#D1FAE5',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A1410',
    '--foreground': '#D1FAE5',
    '--hold-fill': '#047857',
    '--input': '#4A3810',
    '--modal-bg': '#0A1410',
    '--modal-border': '#6B5218',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#2A1E08',
    '--muted-foreground': '#C9A84C',
    '--nav-active': '#047857',
    '--nav-bg': '#102018',
    '--popover': '#102018',
    '--popover-foreground': '#D1FAE5',
    '--primary': '#047857',
    '--primary-foreground': '#0A1410',
    '--ring': '#D4AF37',
    '--secondary': '#1A1408',
    '--secondary-foreground': '#C9A84C',
    '--streak': '#D4AF37',
    '--success': '#22c55e',
    '--success-foreground': '#0A1410',
    '--xp': '#D4AF37',
    '--xp-bg': '#102018'
  },
  resolvedVars: {
    '--accent': '#047857',
    '--accent-foreground': '#0A1410',
    '--accent-foreground-hsl': '156 33% 6%',
    '--accent-foreground-oklch': 'from #0A1410 l c h',
    '--accent-hsl': '163 94% 24%',
    '--accent-oklch': 'from #047857 l c h',
    '--background': '#0A1410',
    '--background-hsl': '156 33% 6%',
    '--background-oklch': 'from #0A1410 l c h',
    '--border': '#6B5218',
    '--border-hsl': '42 63% 26%',
    '--border-oklch': 'from #6B5218 l c h',
    '--border-w': '1px',
    '--card': '#102018',
    '--card-border-active': 'rgba(212,175,55,0.60)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#D1FAE5',
    '--card-foreground-hsl': '149 80% 90%',
    '--card-foreground-oklch': 'from #D1FAE5 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '150 33% 9%',
    '--card-oklch': 'from #102018 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A1410',
    '--destructive-foreground-hsl': '156 33% 6%',
    '--destructive-foreground-oklch': 'from #0A1410 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#D1FAE5',
    '--foreground-hsl': '149 80% 90%',
    '--foreground-oklch': 'from #D1FAE5 l c h',
    '--hold-fill': '#047857',
    '--hold-fill-hsl': '163 94% 24%',
    '--hold-fill-oklch': 'from #047857 l c h',
    '--input': '#4A3810',
    '--input-hsl': '41 64% 18%',
    '--input-oklch': 'from #4A3810 l c h',
    '--modal-bg': '#0A1410',
    '--modal-bg-hsl': '156 33% 6%',
    '--modal-bg-oklch': 'from #0A1410 l c h',
    '--modal-border': '#6B5218',
    '--modal-border-hsl': '42 63% 26%',
    '--modal-border-oklch': 'from #6B5218 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#2A1E08',
    '--muted-foreground': '#C9A84C',
    '--muted-foreground-hsl': '44 54% 54%',
    '--muted-foreground-oklch': 'from #C9A84C l c h',
    '--muted-hsl': '39 68% 10%',
    '--muted-oklch': 'from #2A1E08 l c h',
    '--nav-active': '#047857',
    '--nav-active-hsl': '163 94% 24%',
    '--nav-active-oklch': 'from #047857 l c h',
    '--nav-bg': '#102018',
    '--nav-bg-hsl': '150 33% 9%',
    '--nav-bg-oklch': 'from #102018 l c h',
    '--popover': '#102018',
    '--popover-foreground': '#D1FAE5',
    '--popover-foreground-hsl': '149 80% 90%',
    '--popover-foreground-oklch': 'from #D1FAE5 l c h',
    '--popover-hsl': '150 33% 9%',
    '--popover-oklch': 'from #102018 l c h',
    '--primary': '#047857',
    '--primary-foreground': '#0A1410',
    '--primary-foreground-hsl': '156 33% 6%',
    '--primary-foreground-oklch': 'from #0A1410 l c h',
    '--primary-hsl': '163 94% 24%',
    '--primary-oklch': 'from #047857 l c h',
    '--radius': '12px',
    '--ring': '#D4AF37',
    '--ring-hsl': '46 65% 52%',
    '--ring-oklch': 'from #D4AF37 l c h',
    '--secondary': '#1A1408',
    '--secondary-foreground': '#C9A84C',
    '--secondary-foreground-hsl': '44 54% 54%',
    '--secondary-foreground-oklch': 'from #C9A84C l c h',
    '--secondary-hsl': '40 53% 7%',
    '--secondary-oklch': 'from #1A1408 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#D4AF37',
    '--streak-hsl': '46 65% 52%',
    '--streak-oklch': 'from #D4AF37 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A1410',
    '--success-foreground-hsl': '156 33% 6%',
    '--success-foreground-oklch': 'from #0A1410 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(163 94% 24% / 0.15)',
    '--xp': '#D4AF37',
    '--xp-bg': '#102018',
    '--xp-bg-hsl': '150 33% 9%',
    '--xp-bg-oklch': 'from #102018 l c h',
    '--xp-hsl': '46 65% 52%',
    '--xp-oklch': 'from #D4AF37 l c h'
  }
}
